export default class BlockUpcomingNewsAndEvents {
	static init() {
		this.blocks = document.querySelectorAll(".block-upcoming-news-and-events");

		if(!this.blocks) {
			return;
		}

		this.buildSliders();
	}

	static buildSliders() {
		this.blocks.forEach((block) => {
			const slider = block.querySelector(".swiper-upcoming-events");
			const swiper = new Swiper(slider, {
				loop: false,
				grabCursor: true,
				slidesPerView: 1,
				spaceBetween: "0%",
				speed: 500,
				touchEventsTarget: "container",
				mousewheel: {
					enabled: true,
					releaseOnEdges: true,
					forceToAxis: true,
				},
				navigation: {
					prevEl: '.swiper-button-prev',
					nextEl: '.swiper-button-next',
				},
				// effect: 'fade',
				// fadeEffect: {
				// 	crossFade: true,
				// },
			});
		});
	}
}